import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '../src/assets/styles/btn-styles.css';
import '../src/assets/styles/form-styles.css';
import '../src/assets/styles/table-styles.css';
import '../src/assets/styles/modal-styles.css';
import '../src/assets/styles/file-upload-styles.css';
import reportWebVitals from './reportWebVitals';
import UserLayout from './layouts/UserLayout';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Login from './pages/Login/Login';
import PrivateRoute from './routes/PrivateRoute';
import RedirectRoute from './routes/RedirectRoute';
import { ToastContainer } from 'react-toastify';
import ViewerLayout from './layouts/ViewerLayout';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ToastContainer />
    <Provider store={store}>
      <BrowserRouter> 
        <Routes>
          <Route
            path="/login"
            element={
              <RedirectRoute
                roleRedirects={{
                  admin: "/admin/dashboard",
                  viewer: "/viewer/dashboard",
                }}
              >
                <Login />
              </RedirectRoute>
            }
          />
            <Route
            path="*"
            element={
              <RedirectRoute
                roleRedirects={{ 
                  admin: "/admin/dashboard",
                  viewer: "/viewer/dashboard",
                }}
              >
                <Navigate to="/login" />
              </RedirectRoute>
            }
          />
          <Route
            path="/admin/*"
            element={
              <PrivateRoute
                allowedRoles={["admin"]}
                roleRedirects={{
                  admin: "/admin/dashboard",
                  viewer: "/viewer/dashboard",
                }}
              >
                <UserLayout />
              </PrivateRoute>
            }
          />
            <Route
            path="/viewer/*"
            element={
              <PrivateRoute
                allowedRoles={["viewer"]}
                roleRedirects={{
                  admin: "/admin/dashboard",
                  viewer: "/viewer/dashboard",
                }}
              >
                <ViewerLayout />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
